(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6293],{

/***/ 10796:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]",
      function () {
        return __webpack_require__(60676);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ StageImageButtonToken; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13692);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92212);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93217);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43067);
/* harmony import */ var _stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27397);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var StageImageButtonToken = function(_param) {
    var image = _param.image, editButtonProps = _param.editButtonProps, shadow = _param.shadow, props = _objectWithoutProperties(_param, [
        "image",
        "editButtonProps",
        "shadow"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), src = ref[0], setSrc = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setSrc("".concat(image, "?resolution=thumbnail"));
    }, [
        image
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token"]),
        children: [
            (props === null || props === void 0 ? void 0 : props.hasLink) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_5__/* .LinkBase */ .w, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["stage-image-button-token-link"]),
                href: props.href,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                    variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                    className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                    icon: {
                        element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: src,
                            onError: function() {
                                return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                            }
                        }),
                        align: "left"
                    },
                    buttonUrl: ""
                }))
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, props, {
                variant: shadow ? _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.STAGE */ .l.STAGE : _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_3__/* .ButtonVariantsEnum.SECONDARY_FILLED */ .l.SECONDARY_FILLED,
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["token-button"]),
                icon: {
                    element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: src,
                        onError: function() {
                            return setSrc(_assets_creatoki_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src);
                        }
                    }),
                    align: "left"
                },
                buttonUrl: ""
            })),
            editButtonProps && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, _objectSpread({}, editButtonProps, {
                className: (_stage_image_button_token_module_scss__WEBPACK_IMPORTED_MODULE_6___default().editButton)
            }))
        ]
    });
};



/***/ }),

/***/ 60676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _username_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(80880);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/api/hooks/useMyOan.hook.tsx
var useMyOan_hook = __webpack_require__(12207);
// EXTERNAL MODULE: ./src/assets/creatoki.png
var creatoki = __webpack_require__(13692);
// EXTERNAL MODULE: ./src/components/_shared/header/default-header/default-header.tsx + 9 modules
var default_header = __webpack_require__(4302);
// EXTERNAL MODULE: ./src/components/_shared/header-footer-wrapper/header-footer-wrapper.tsx
var header_footer_wrapper = __webpack_require__(3143);
// EXTERNAL MODULE: ./src/components/_shared/meta-tags-resolver/meta-tags-resolver.tsx
var meta_tags_resolver = __webpack_require__(66743);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-toast-notifications/dist/index.js
var dist = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/utils/_enums/social-networks.enum.ts
var social_networks_enum = __webpack_require__(92574);
// EXTERNAL MODULE: ./src/utils/_enums/toaster-types.enum.tsx
var toaster_types_enum = __webpack_require__(18152);
// EXTERNAL MODULE: ./src/utils/_enums/typeography-variants.enum.tsx
var typeography_variants_enum = __webpack_require__(77872);
// EXTERNAL MODULE: ./src/utils/_helper/strapi-mapper.tsx
var strapi_mapper = __webpack_require__(962);
// EXTERNAL MODULE: ./src/utils/_helper/truncate-string-helper.ts
var truncate_string_helper = __webpack_require__(18841);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/stage/stage-image-button-token/stage-image-button-token.tsx
var stage_image_button_token = __webpack_require__(58523);
// EXTERNAL MODULE: ./src/components/_shared/typography/typography.tsx
var typography = __webpack_require__(28773);
// EXTERNAL MODULE: ./src/components/my-oan/my-oan-stage/my-oan-stage.module.scss
var my_oan_stage_module = __webpack_require__(17901);
var my_oan_stage_module_default = /*#__PURE__*/__webpack_require__.n(my_oan_stage_module);
;// CONCATENATED MODULE: ./src/components/my-oan/my-oan-stage/my-oan-stage.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














var MyOanStage = function(param) {
    var username = param.username, description = param.description, inverted = param.inverted, background = param.background, decButton = param.decButton, socialNetworks = param.socialNetworks, walletId = param.walletId, titleElement = param.titleElement, titleVariant = param.titleVariant;
    var ref, ref1;
    var data = (0,useMyOan_hook/* useMyOan */.o)();
    var addToast = (0,dist/* useToasts */.e1)().addToast;
    var copyWalletAddress = function() {
        if (walletId) {
            var ta = document.createElement("textarea");
            ta.innerText = walletId;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            ta.remove();
            addToast(data.copiedSuccessfully, {
                appearance: toaster_types_enum/* ToasterTypes.SUCCESS */.p.SUCCESS
            });
        }
    };
    var getSocialNetworkIcon = function(socialNetwork) {
        switch(socialNetwork){
            case social_networks_enum/* SocialNetworksEnum.FACEBOOK */.S.FACEBOOK:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "fab",
                        "facebook-f"
                    ],
                    className: (my_oan_stage_module_default())["oan-icon-facebook"]
                });
            case social_networks_enum/* SocialNetworksEnum.INSTAGRAM */.S.INSTAGRAM:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "fab",
                        "instagram"
                    ],
                    className: (my_oan_stage_module_default())["oan-icon"]
                });
            case social_networks_enum/* SocialNetworksEnum.TWITTER */.S.TWITTER:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "fab",
                        "twitter"
                    ],
                    className: (my_oan_stage_module_default())["oan-icon"]
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((my_oan_stage_module_default()).stage, " ").concat((my_oan_stage_module_default()).Small),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                backgroundImage: "url(".concat(background, ")"),
                backgroundSize: "cover",
                backgroundPosition: "top right"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(inverted ? (my_oan_stage_module_default()).inverted : "", " ").concat((my_oan_stage_module_default()).CENTER),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (my_oan_stage_module_default()).title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        disableMarkdown: true,
                                        variant: titleVariant ? (0,strapi_mapper/* mapStrapiHeadline */.z)(titleVariant) : typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1,
                                        element: titleElement ? titleElement : "h1",
                                        children: username ? (data === null || data === void 0 ? void 0 : (ref = data.stage) === null || ref === void 0 ? void 0 : (ref1 = ref.headline) === null || ref1 === void 0 ? void 0 : ref1.headlineContent) + " @" + username : ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (my_oan_stage_module_default()).description,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                        variant: typeography_variants_enum/* TypographyVariantsEnum.INTROTEXT */.H.INTROTEXT,
                                        children: description
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (my_oan_stage_module_default())["social-network-buttons"],
                            children: socialNetworks === null || socialNetworks === void 0 ? void 0 : socialNetworks.map(function(socialNetwork) {
                                if (socialNetwork.url) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        target: "_blank",
                                        href: socialNetwork.url,
                                        rel: "noopener noreferrer",
                                        className: (my_oan_stage_module_default())["social-network-link"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                            className: (my_oan_stage_module_default())["social-network-button"],
                                            icon: {
                                                element: getSocialNetworkIcon(socialNetwork.socialNetwork),
                                                align: "left"
                                            }
                                        }, socialNetwork.id)
                                    });
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (my_oan_stage_module_default()).decButtonContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stage_image_button_token/* StageImageButtonToken */.k, _objectSpread({}, decButton, {
                                image: decButton.image,
                                shadow: true
                            }))
                        }),
                        walletId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (my_oan_stage_module_default())["wallet-address-wrapper"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                    disableMarkdown: true,
                                    variant: typeography_variants_enum/* TypographyVariantsEnum.CAPTION */.H.CAPTION,
                                    element: "span",
                                    children: data.walletId
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (my_oan_stage_module_default())["wallet-address"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                                            children: (0,truncate_string_helper/* default */.Z)(walletId, 6, 4)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (my_oan_stage_module_default())["copy-icon-wrapper"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: [
                                                    "far",
                                                    "copy"
                                                ],
                                                onClick: copyWalletAddress
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : undefined
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var my_oan_stage = (MyOanStage);

// EXTERNAL MODULE: ./src/redux/index.tsx + 21 modules
var redux = __webpack_require__(37287);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./src/utils/_hooks/useBreakpoints.hook.ts
var useBreakpoints_hook = __webpack_require__(93890);
// EXTERNAL MODULE: ./src/components/_shared/spacer/spacer.tsx
var spacer = __webpack_require__(4363);
// EXTERNAL MODULE: ./src/components/_shared/teaser/teaser.tsx + 1 modules
var teaser = __webpack_require__(10725);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card/teaser-card.tsx + 17 modules
var teaser_card = __webpack_require__(33076);
// EXTERNAL MODULE: ./src/components/_shared/text-section/text-section.tsx
var text_section = __webpack_require__(29209);
// EXTERNAL MODULE: ./src/components/my-oan/my-oan-teaser/my-oan-teaser.module.scss
var my_oan_teaser_module = __webpack_require__(70677);
var my_oan_teaser_module_default = /*#__PURE__*/__webpack_require__.n(my_oan_teaser_module);
;// CONCATENATED MODULE: ./src/components/my-oan/my-oan-teaser/my-oan-teaser.tsx















var MyOanTeaser = function() {
    var data = (0,useMyOan_hook/* useMyOan */.o)();
    var breakpoint = (0,useBreakpoints_hook/* default */.Z)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref19 = (0,redux/* useAppSelector */.CG)(function(state) {
        var ref;
        return {
            instances: state.productSlice.myOanInstances,
            myOanId: (ref = state.myOanSlice.user) === null || ref === void 0 ? void 0 : ref.id,
            user: state.userSlice.user,
            walletId: state.blockchainSlice.walletId,
            addToBasketModelPending: state.checkoutSlice.pending,
            addToBasketStatus: state.checkoutSlice.addToBasketStatus
        };
    }), myOanId = ref19.myOanId, instances = ref19.instances, user = ref19.user, walletId = ref19.walletId, addToBasketModelPending = ref19.addToBasketModelPending, addToBasketStatus = ref19.addToBasketStatus;
    (0,react.useEffect)(function() {
        if (myOanId) {
            dispatch((0,redux/* fetchMyOanInstances */.$r)(myOanId));
        }
    }, []);
    if (!myOanId || (instances === null || instances === void 0 ? void 0 : instances.fulfilled) && (instances === null || instances === void 0 ? void 0 : instances.data.length) === 0) {
        var ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
        var ref15, ref16, ref17, ref18;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (my_oan_teaser_module_default())["my-oan-teaser-wrapper"],
            children: [
                breakpoint !== "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* Spacer */.L, {
                    height: "50px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Typography */.Z, {
                    className: (ref15 = data === null || data === void 0 ? void 0 : (ref1 = data.noNftNote) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.title) === null || ref2 === void 0 ? void 0 : ref2.cssClass) !== null && ref15 !== void 0 ? ref15 : "",
                    element: (ref16 = data === null || data === void 0 ? void 0 : (ref3 = data.noNftNote) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.title) === null || ref4 === void 0 ? void 0 : ref4.element) !== null && ref16 !== void 0 ? ref16 : "",
                    variant: (0,strapi_mapper/* mapStrapiHeadline */.z)(data === null || data === void 0 ? void 0 : (ref5 = data.noNftNote) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.title) === null || ref6 === void 0 ? void 0 : ref6.style),
                    style: {
                        textAlign: (ref17 = data === null || data === void 0 ? void 0 : (ref7 = data.noNftNote) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.title) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.textAlign) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.toLowerCase) === null || ref10 === void 0 ? void 0 : ref10.call(ref9)) !== null && ref17 !== void 0 ? ref17 : "left"
                    },
                    children: data === null || data === void 0 ? void 0 : (ref11 = data.noNftNote) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.title) === null || ref12 === void 0 ? void 0 : ref12.headlineContent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_section/* default */.Z, {
                    description: (ref18 = data === null || data === void 0 ? void 0 : (ref13 = data.noNftNote) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.description) === null || ref14 === void 0 ? void 0 : ref14.content) !== null && ref18 !== void 0 ? ref18 : ""
                })
            ]
        });
    } else {
        if ((instances === null || instances === void 0 ? void 0 : instances.data) && instances.data.length > 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (my_oan_teaser_module_default())["my-oan-teaser-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser/* default */.Z, {
                    headline: data ? data.ownedItemsHeadline.headlineContent : "",
                    hideTeaserButtons: true,
                    maxCards: instances.maxNumber,
                    headlineElement: "h2",
                    headlineVariant: typeography_variants_enum/* TypographyVariantsEnum.HEADING1 */.H.HEADING1,
                    withNumbers: true,
                    pending: instances.pending,
                    pagination: instances.pagination,
                    cards: instances.data.slice(0).map(function(instance) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card/* default */.Z, {
                            instance: instance
                        }, "my-oan-instance-".concat(instance.id));
                    }),
                    onLoadNewItems: function() {
                        return undefined;
                    },
                    type: basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_SMALL */.I.BASIC_CARD_SMALL
                })
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
        }
    }
};
/* harmony default export */ var my_oan_teaser = (MyOanTeaser);

// EXTERNAL MODULE: ./src/redux/slices/my-oan.slice.tsx
var my_oan_slice = __webpack_require__(85841);
// EXTERNAL MODULE: ./src/utils/_enums/route-path.enum.tsx
var route_path_enum = __webpack_require__(16837);
// EXTERNAL MODULE: ./src/utils/_hooks/hooks.tsx
var hooks = __webpack_require__(62251);
;// CONCATENATED MODULE: ./src/views/my-oan/my-oan.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














var MyOan = function() {
    var data = (0,useMyOan_hook/* useMyOan */.o)();
    var router = (0,client_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref12 = (0,hooks/* useAppSelector */.C)(function(state) {
        return {
            user: state.myOanSlice.user,
            fetchUserStatus: state.myOanSlice.fetchStatus
        };
    }), user = ref12.user, fetchUserStatus = ref12.fetchUserStatus;
    (0,react.useEffect)(function() {
        dispatch((0,my_oan_slice/* fetchMyOanUser */.OQ)(router.query.username));
    }, []);
    (0,react.useEffect)(function() {
        if (fetchUserStatus && fetchUserStatus !== 200) {
            router.push(route_path_enum/* RoutePath.ERROR_PAGE */.h3.ERROR_PAGE);
        }
    }, [
        fetchUserStatus
    ]);
    var metaTagTitle = function() {
        var ref;
        return (data === null || data === void 0 ? void 0 : (ref = data.meta) === null || ref === void 0 ? void 0 : ref.metaTagTitle) && (user === null || user === void 0 ? void 0 : user.username) ? data.meta.metaTagTitle + user.username : "";
    };
    if (fetchUserStatus === 200) {
        var ref1, ref2, ref3, ref4, ref5, ref6;
        var ref7, ref8, ref9, ref10, ref11;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(meta_tags_resolver/* MetaTagsResolver */.H, {
                    tags: data === null || data === void 0 ? void 0 : data.meta,
                    title: metaTagTitle()
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(header_footer_wrapper/* HeaderFooterWrapper */.u, {
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_header/* DefaultHeader */.y, {
                        availableLanguages: data === null || data === void 0 ? void 0 : data.localizations
                    }),
                    stage: /*#__PURE__*/ (0,jsx_runtime.jsx)(my_oan_stage, {
                        username: (ref7 = user === null || user === void 0 ? void 0 : user.username) !== null && ref7 !== void 0 ? ref7 : "",
                        walletId: (ref8 = user === null || user === void 0 ? void 0 : user.wallet) !== null && ref8 !== void 0 ? ref8 : "",
                        description: (ref9 = user === null || user === void 0 ? void 0 : user.userDescription) !== null && ref9 !== void 0 ? ref9 : "",
                        decButton: {
                            image: (user === null || user === void 0 ? void 0 : user.profileImageUrl) ? user.profileImageUrl : creatoki/* default.src */.Z.src
                        },
                        titleVariant: data === null || data === void 0 ? void 0 : (ref1 = data.stage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.headline) === null || ref2 === void 0 ? void 0 : ref2.style,
                        socialNetworks: (ref10 = user === null || user === void 0 ? void 0 : user.socialNetworks) !== null && ref10 !== void 0 ? ref10 : [],
                        background: data === null || data === void 0 ? void 0 : (ref3 = data.stage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.background) === null || ref4 === void 0 ? void 0 : ref4.url,
                        inverted: (ref11 = data === null || data === void 0 ? void 0 : (ref5 = data.stage) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.componentStyles) === null || ref6 === void 0 ? void 0 : ref6.inverted) !== null && ref11 !== void 0 ? ref11 : false
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(my_oan_teaser, {})
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
};
/* harmony default export */ var my_oan = (MyOan);
MyOan.dataHooks = _toConsumableArray(header_footer_wrapper/* HeaderFooterWrapper.dataHooks */.u.dataHooks).concat([
    useMyOan_hook/* useMyOan */.o
], _toConsumableArray(meta_tags_resolver/* MetaTagsResolver.dataHooks */.H.dataHooks));

;// CONCATENATED MODULE: ./src/pages/user/[username].tsx

var __N_SSP = true;
/* harmony default export */ var _username_ = (my_oan);


/***/ }),

/***/ 92574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ SocialNetworksEnum; }
/* harmony export */ });
var SocialNetworksEnum;
(function(SocialNetworksEnum) {
    SocialNetworksEnum["TWITTER"] = "Twitter";
    SocialNetworksEnum["FACEBOOK"] = "Facebook";
    SocialNetworksEnum["INSTAGRAM"] = "Instagram";
})(SocialNetworksEnum || (SocialNetworksEnum = {}));


/***/ }),

/***/ 18841:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var truncateString = function(str, maxLettersBeforeTruncate, maxLettersAfterTruncate) {
    if (maxLettersBeforeTruncate + maxLettersAfterTruncate >= str.length) {
        return str;
    } else {
        return str.substring(0, maxLettersBeforeTruncate) + "..." + str.substring(str.length - maxLettersAfterTruncate);
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateString);


/***/ }),

/***/ 43067:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stage-image-button-token":"stage-image-button-token_stage-image-button-token__NZS_U","stage-image-button-token-link":"stage-image-button-token_stage-image-button-token-link__aBRfn","editButton":"stage-image-button-token_editButton__E4dxD"};

/***/ }),

/***/ 17901:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","stage":"my-oan-stage_stage___gEcL","Large":"my-oan-stage_Large___k_6q","Small":"my-oan-stage_Small___fGso","Center":"my-oan-stage_Center__PaMnC","inverted":"my-oan-stage_inverted__3s00x","CENTER":"my-oan-stage_CENTER__vis7K","decButtonContainer":"my-oan-stage_decButtonContainer__5qSOB","title":"my-oan-stage_title__FzKOz","description":"my-oan-stage_description__iwHez","social-network-buttons":"my-oan-stage_social-network-buttons__c__HA","social-network-link":"my-oan-stage_social-network-link__eyEll","social-network-button":"my-oan-stage_social-network-button__I84pd","wallet-address-wrapper":"my-oan-stage_wallet-address-wrapper__gqA9v","wallet-address":"my-oan-stage_wallet-address__xPCPJ","copy-icon-wrapper":"my-oan-stage_copy-icon-wrapper__sBAFK"};

/***/ }),

/***/ 70677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"my-oan-teaser-wrapper":"my-oan-teaser_my-oan-teaser-wrapper__SIz_6"};

/***/ }),

/***/ 86037:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(67294)) :
  0;
}(this, (function (exports, React) {
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return n;
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
        if (absX < delta && absY < delta && !state.swiping) return state;
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        };
        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
        props.onSwiping && props.onSwiping(eventData);
        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped" + eventData.dir];
          onSwipedDir && onSwipedDir(eventData);
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };

    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        });

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      if (el === null) return;
      set(function (state, props) {
        if (state.el === el) return state;
        var addState = {};

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = void 0;
        }

        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        }

        return _extends({}, state, {
          el: el
        }, addState);
      });
    };

    var output = {
      ref: onRef
    };

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {};

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = void 0;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React__namespace.useRef(_extends({}, initialState));
    var transientProps = React__namespace.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options, {
      delta: options.delta === void 0 ? defaultProps.delta : options.delta,
      rotationAngle: options.rotationAngle === void 0 ? defaultProps.rotationAngle : options.rotationAngle,
      trackTouch: options.trackTouch === void 0 ? defaultProps.trackTouch : options.trackTouch
    });

    var _React$useMemo = React__namespace.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,4577,9866,6586,8760,6067,855,725,2888,179], function() { return __webpack_exec__(10796); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);